module.exports = __webpack_public_path__ + "img/promotion.dcf4d241.svg";